import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CatalogsComponent } from "./pages/catalogs/catalogs.component";
import { PoComponent } from "./pages/po/po.component";
import { GpioComponent } from "./pages/gpio/gpio.component";
import { ModelsComponent } from "./pages/models/models.component";
import { HomeComponent } from "./pages/home/home.component";
import { ReportsComponent } from "./pages/reports/reports.component";
import { authGuard, welcomeGuard, adminGuard } from "./auth.guard";

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/home' },
  {
    path: 'welcome',
    loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent),
    canActivate: [welcomeGuard]
  },
  { path: 'home', component: HomeComponent, canActivate: [authGuard] },
  { path: 'home/filters', component: HomeComponent, canActivate: [authGuard] },
  { path: 'home/debug', redirectTo: 'home/debug/logging', pathMatch: 'full' },
  { path: 'home/debug/:tab', component: HomeComponent, canActivate: [authGuard] },
  { path: 'catalogs', component: CatalogsComponent, canActivate: [authGuard] },
  { path: 'models', component: ModelsComponent, canActivate: [authGuard] },
  { path: 'gpio', component: GpioComponent, canActivate: [authGuard] },
  { path: 'reports', component: ReportsComponent, canActivate: [authGuard] },
  {
    path: 'pos/:poId/scans/:scanId/details',
    component: PoComponent,
    data: { tab: 'details' },
    canActivate: [authGuard]
  },
  {
    path: 'pos/:poId/scans/:scanId',
    component: PoComponent,
    canActivate: [authGuard]
  },
  {
    path: 'pos/:poId/analysis',
    component: PoComponent,
    data: { tab: 'analysis' },
    canActivate: [authGuard]
  },
  {
    path: 'pos/:poId', component: PoComponent,
    canActivate: [authGuard]
  },
  {
    path: 'sm-debug',
    redirectTo: 'sm-debug/graphviz',
    pathMatch: 'full'
  },
  {
    path: 'sm-debug/:tab',
    loadComponent: () => import('./pages/sm-debug/sm-debug.component').then(m => m.SmDebugComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'debug',
    redirectTo: 'debug/logging',
    pathMatch: 'full'
  },
  {
    path: 'debug/:tab',
    loadComponent: () => import('./pages/app-debug/app-debug.component').then(m => m.AppDebugComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'manage-roles',
    loadComponent: () => import('./pages/manage-roles/manage-roles.component').then(m => m.ManageRolesComponent),
    canActivate: [authGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
